import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { OptionItem } from 'src/app/model/optionItem';

@Component({
    selector: 'app-sort-builder',
    templateUrl: './sort-builder.component.html',
    styleUrls: ['./sort-builder.component.css'],
    standalone: false
})
export class SortBuilderComponent implements OnInit {
  
  sortItems: SortInfo[] = [];
  fields: string[];
  selectedSortInfo?: SortInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SortBuilderComponent>) {
      this.fields = data.fields;
      this.fields.sort( (a, b) => a < b ? -1 : 0);
      this.sortItems = data.sortItems;

      // remove fields which are in sortItems to avoid dups
      this.sortItems.forEach(x => {
        const index = this.fields.findIndex(f => f === x.sortField);
        if (index >= 0) {
          this.fields.splice(index, 1);
        }
      });
    }

  ngOnInit(): void {
  }
  
  // sortInfoSelected(event: any): void {
  //   this.selectedSortInfo = event.option.value;
  // }
  sortInfoSelected(sortInfo: SortInfo): void {
    if(sortInfo.sortAscending){
      sortInfo.sortAscending=false;
    }
    else{
      sortInfo.sortAscending=true;
    }
  }
  removeItem(item: SortInfo): void {
    const index = this.sortItems.indexOf(item);
    if (index >= 0) {
      this.sortItems.splice(index, 1);
    }

    this.fields.push(item.sortField);
    this.fields.sort( (a, b) => a < b ? -1 : 0);
    this.selectedSortInfo = null;
  }

  saveChanges(): void {
    this.dialogRef.close({sortItems: this.sortItems });
  }

  newItem(option: any): void {
    if (!option || option.length === 0 ) {
       return;
    }

    const info = new SortInfo();
    info.sortField = option;
    info.sortAscending = true;

    const index = this.fields.indexOf(option);
    if (index >= 0) {
      this.fields.splice(index, 1);
    }
    
    this.sortItems.push( info );
  }
}
